import React, { useState, useEffect } from "react";
import axios from '../helper/axios';
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useUser } from "../Provider";

const SearchPathologyCategory = ({ onPathologyCategoryChange, hospitalvalue }) => {
    const { userrole1, token } = useUser();
    const [data,setCategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [openAutocomplete, setOpenAutocomplete] = useState(false);

    useEffect(() => {
        fetchcategoryName ();
        setSelectedCategory("")
    }, [hospitalvalue, userrole1]);

    const fetchcategoryName  = async () => {
        try {
          const response = await axios.get("/pathologycategory", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              hospitalcode:hospitalvalue,
            },
          });
    console.log(response.data)
          if (response.status === 200) {
            setCategory(response.data);
          } else {
            console.error(`Failed to fetch available unit with status: ${response.status}`);
          }
        } catch (error) {
          console.error('Error fetching available unit:', error.message);
        }
      };

    const handleCategoryChange = (event, value) => {
      if (value) {
        setSelectedCategory(value);
        onPathologyCategoryChange(value);
    } else {
        // Handle the case when no value is selected
        setSelectedCategory('');
    }
    };
    const getOptionLabel = (option) => {
      // Handle the case when option is null or undefined
      return option?.categoryname|| '';
  };
  const handleExpandClick = () => {
    setOpenAutocomplete(!openAutocomplete);
};
    return (
        <div className="searchbar">
            <Autocomplete
                freeSolo
                id="free-solo"
                options={data}
                getOptionLabel={getOptionLabel}
                open={openAutocomplete}
                onOpen={() => setOpenAutocomplete(true)}
                onClose={() => setOpenAutocomplete(false)}
                value={selectedCategory}
                onChange={handleCategoryChange}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        placeholder="Select Pathology Category"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleExpandClick}>
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                }
            />
        </div>
    );
};

export default SearchPathologyCategory;
